import axios from "axios";

export const sendFeedback = async (rating, message) => {
    
  try {
    const response = await axios.post(
      `https://splitpro.netlify.app/.netlify/functions/sendFeedback`,
      {
        rating,
        message
      }
    );
    const result = response.data.message;    

    if (result) {
      return result;
    }
    return null;
  } catch (error) {
    console.error("Error sending feedback:", error);
    return null;
  }
};
